import { preview } from '@/components/form/preview'
import { useTexts } from './hooks/useTexts'
//import { Restrictions } from './Restrictions'

type Props = {
  voice: uui.domain.server.rm.VoiceConfig
}

export function OffAdvancedProperties(props: Props) {
  const { voice } = props
  const texts = useTexts()

  if (voice.status !== 'ADVANCED' || voice.callbackConfig.status !== 'OFF') return null

  const messageOnCallbackTitle = voice.callbackConfig.automatedMessageEnabled
    ? texts.value.messageOnCallback.on
    : texts.value.messageOnCallback.off
  const voicePerformance =
    voice.callbackConfig.automatedMessageVoice &&
    `${voice.callbackConfig.automatedMessageVoice[0]}${voice.callbackConfig.automatedMessageVoice
      .substring(1)
      .toLowerCase()}`

  return (
    <>
      {/*
      //TODO: Re-enable that field once it will be available

      <ViewField label={texts.labels.restrictions}>
        <Restrictions voice={voice} />
      </ViewField>
      */}
      <preview.Field testId="voice-customer-callback-preference" label={texts.labels.preference}>
        {texts.value.preference.off}
      </preview.Field>

      <preview.Field testId="voice-message-on-callback" label={texts.labels.messageOnCallback}>
        {messageOnCallbackTitle}
      </preview.Field>
      {voice.callbackConfig.automatedMessageEnabled ? (
        <>
          <preview.Field testId="voice-message" label={texts.labels.message}>
            {voice.callbackConfig.automatedMessage}
          </preview.Field>
          <preview.Field testId="voice-preference" label={texts.labels.voicePreference}>
            {voicePerformance}
          </preview.Field>
        </>
      ) : null}
    </>
  )
}
